import type { TenantConfig } from '@/types/TenantConfig'

export const kidspace: TenantConfig = {
  logo: 'assets/kidspace/static/logo.png',
  componentOptions: {
    cartWidget: {
      dateTimeFormat: 'ddd MMM D YYYY',
    },
    eventDetailRoute: {
      showVenue: true,
    },

    checkoutRoute: {
      stripeWallets: true,
    },
  },
  i18nOverrides: {
    en: {
      homeRoute: {
        title: 'Log in, Sign up or continue as a Guest',
        guestButton: 'Continue as a guest',
        signupButton: 'Become a member',
        loginTitle: 'Member Login',
        signupTitle: 'I don’t have a membership – Sign me up',
      },
      cartExpire: {
        title: 'Oh, No!',
        message: 'Unfortunately, your order has timed out.',
      },
      selectDate: {
        tooltip: 'Choose a date',
      },
      reserveDateFirst: {
        selectDateLabel: 'Choose a date',
      },
      membersOnly: {
        title: 'Join us!',
        description: 'Members enjoy special access to experiences like this one.',
        loginLinkLabel: 'ALREADY A MEMBER?',
        signupTemplate: 'Not a member? <membership-link>Join or renew today</membership-link>',
      },
      memberRoleLabels: {
        child: 'child member | child members',
        'child-member': 'child member | child members',
      },
    },
  },
  customContent: [
    {
      key: 'member-benefits',
      regions: ['home-member-benefits'],
      template: `
        <div>
          <p>Membership allows you to experience all that the Kidspace has to offer, at great value!</p>
          <ul>
            <li>Free general admission</li>
            <li>Free admission to more than 300 museums around the world</li>
            <li>Discounts on paid events and programs</li>
          </ul>
        </div>
      `,
    },
    {
      key: 'guest-shopping',
      regions: ['home-guest-experience'],
      template: `
        <p>You can purchase tickets as a guest without having to register.</p>
      `,
    },
  ],
}
